/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {ActiveToast, IndividualConfig, ToastrService} from 'ngx-toastr';
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ToastWrapperService {

    private readonly WARNING_TIMEOUT = 10000;

    constructor(private toastr: ToastrService) {
    }

    success(message?: string, title?: string, override?: Partial<IndividualConfig>): ActiveToast<any> {
        const newOverride = Object.assign({}, override);
        return this.toastr.success(message, title, newOverride);
    }

    error(message?: string, title?: string, override?: Partial<IndividualConfig>): ActiveToast<any> {
        const newOverride = Object.assign({}, override, {disableTimeOut: true});
        return this.toastr.error(message, title, newOverride);
    }

    info(message?: string, title?: string, override?: Partial<IndividualConfig>): ActiveToast<any> {
        const newOverride = Object.assign({}, override);
        return this.toastr.info(message, title, newOverride);
    }

    warning(message?: string, title?: string, override?: Partial<IndividualConfig>): ActiveToast<any> {
        const newOverride = Object.assign({}, override, {timeOut: this.WARNING_TIMEOUT});
        return this.toastr.warning(message, title, newOverride);
    }
}
